import { useController } from "react-hook-form";
import { useDialogState } from "../../../../hooks/useDialogState";
import { FieldMessage, FormFieldWrapper } from "../../forms/FormField";
import { Button } from "@mui/material";
import { T } from "../../../util/t";
import { DivisionBox } from "../../../divisions/divisionBox";
import { ResponsiveDialog } from "../../../modal";
import { SelectOptionsDialog } from "./SelectOptionsDialog";

const singularise = (plural) =>
    plural.slice(0,-1);

export const SelectOptionsField = ({ field, control, getValues }) => {
    const waitlisted = !!field.registrationOptions?.waitlisted;
    const optionsLabel = field.label.toLowerCase();
    const { field: input, fieldState } = useController({
        control,
        name: field.name,
        rules: { validate: value => {
            if (value.length === 0) return `They'll need to enter at least one ${singularise(optionsLabel)}.`;
            if (!value.find((option) => option.id === undefined)) {
                if (!waitlisted && getValues(`athletes.${field.index}.extras`)?.length > 0) return undefined;
                return `Already registered. Add a new ${singularise(optionsLabel)} or remove athlete.`;
            }
            return undefined;
        } },
    });
    const [dialogOpen, openDialog, closeDialog] = useDialogState();
    const removeOption = index => {
        input.value.splice(index, 1);
        input.onChange(input.value);
    };
    const toggleOption = (e, option) => {
        if (e.target.checked) {
            input.value.push({ option_id: option.optionId, name: option.name });
            input.onChange(input.value);
        } else {
            const index = input.value.findIndex(selectedOption => selectedOption.option_id === option.optionId);
            removeOption(index);
        }
    };

    return (
        <FormFieldWrapper label={field.label}>
            {input.value.map((option, index) =>
                <DivisionBox
                    key={option.option_id}
                    name={option.name}
                    onRemove={!option.id && (() => removeOption(index))}
                    disabled={!!option.id}
                    fullWidth
                />
            )}
            <Button ref={input.ref} variant="outlined" onClick={openDialog} fullWidth>
                <T>{`Add ${optionsLabel}`}</T>
            </Button>
            <FieldMessage errorMessage={fieldState.error?.message}/>

            <ResponsiveDialog
                className="lh-dialog"
                open={dialogOpen}
                onClose={closeDialog}
                fullWidth={true}
                maxWidth="sm"
                aria-labelledby="divisions-selector-dialog-title">
                <SelectOptionsDialog
                    options={field.options}
                    toggleOption={toggleOption}
                    closeDialog={closeDialog}
                    control={control}
                    index={field.index}
                    registrationOptions={field.registrationOptions}
                    paymentOptions={field.paymentOptions}
                    isSeriesRegistration={optionsLabel === "membership options"}
                />
            </ResponsiveDialog>
        </FormFieldWrapper>
    );
};
